import type { SyntheticEvent } from 'react';

export const isKeyboardEvent = (event?: SyntheticEvent): boolean => {
  // @ts-ignore
  return event?.nativeEvent?.clientX === 0 && event?.nativeEvent?.clientY === 0;
};
